// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"6b4386e9","396":"e1df4c8d","444":"2539aa3b","453":"c98f078b","537":"46b39de6","863":"7cdbbc46","934":"40668dd8"}[chunkId] + ".chunk.js";
};